import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M16.667 17.5v-1.667a3.333 3.333 0 0 0-3.334-3.333H6.668a3.333 3.333 0 0 0-3.333 3.333V17.5m10-11.667a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0"
    }, null, -1)
  ]))]))
}
export default { render: render }